module.exports = __webpack_public_path__ + "static/media/flow.2cf4488c.svg";